export const PATIENTS = '/patients'
export const PATIENTSINFO = '/patients/:id'
